import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`About`}</h2>
    <h4>{`A tech enthusiast, a web developer and a CSE undergraduate. Fluent with trending technologies like:`}</h4>
    <ul>
      <li parentName="ul">{`MERN Stack`}</li>
      <li parentName="ul">{`Machine Learning`}</li>
      <li parentName="ul">{`Data Structures and Algorithms using Java`}</li>
      <li parentName="ul">{`Python`}</li>
    </ul>
    <p>{`I have few internships with frontend development using React, Java development and software engineering in few startups.
A certified Android developer(by HPES), Core java developer(by MTA) and IOT developer(by MyCaptain). I love to spend my time in Competitive programming as well. Here's my `}<a parentName="p" {...{
        "href": "https://www.hackerrank.com/dcoolguydev"
      }}>{`hackerrank`}</a>{`, `}<a parentName="p" {...{
        "href": "https://www.codechef.com/blackwatch1910"
      }}>{`codechef`}</a>{`, `}<a parentName="p" {...{
        "href": "https://www.https://leetcode.com/blackwatch1910/"
      }}>{`leetcode`}</a>{` links.
To know me more, here's my `}<a parentName="p" {...{
        "href": "https://1drv.ms/b/s!AvlKchCjjPYFgpxA1Tnldy8xA1wkpQ?e=FEuXqI"
      }}>{`resume`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      